<template lang="pug">
  div
    .columns.is-mobile.has-text-centered
      .column.is-12
        VueSignaturePad#signature(
          width="250px"
          height="250px"
          ref="signaturePad"
          :options="options"
          v-show="isShow"
        )
    .columns.has-text-centered
      .column.is-12
        a.button.is-dark.is-rounded(@click='resetCanvas') Limpiar
        | &nbsp
        a.button.is-primary.is-rounded(@click='saveFirma') Firmar
</template>

<script>

  export default {
    name: 'Signature',
    data() {
      return {
        options: {
          penColor: "#020ca2"
        },
        file: '',
        isShow: false
      }
    },
    methods: {
      iniciarcomponente() {
        this.showWithResize()
      },
      resetCanvas() {
        console.log(this.$refs.signaturePad)
        this.$refs.signaturePad.undoSignature()
      },
      saveFirma () {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        if (isEmpty) {
          this.file = 'NoData'
        } else {
          this.file = data
        }
        this.$emit('saveFile', this.file)
      },
      showWithResize() {
        this.isShow = true
        this.$refs.signaturePad.$refs.signaturePadCanvas.width = 250
        this.$refs.signaturePad.$refs.signaturePadCanvas.height = 250
      },
    },
    created () {
      
    },
    mounted () {
      console.log(`Mounted: isShow: ${this.isShow}`)
      this.iniciarcomponente()
    },

  }
</script>

<style lang="css" scoped>
  #signature {
    border: 2px solid #00d1b2;
    cursor:crosshair;
    border-radius: 5%;
    margin: 0 auto;
  }

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Signature.vue